import React from "react";
import { Button, Input } from "@material-ui/core";
import "./EasyRange.css";

const easyRange = props => (
  <div style={{ display: "flex" }}>
    <Button variant="fab" mini className="EasyRangeFab" onClick={props.minus}>
      -
    </Button>

    <Input
      value={props.number}
      style={{ width: "50px", margin: '0px 10px' }}
      className="EasyInput"
      onChange={(e) => props.change(e)}
    />
    <Button variant="fab" mini className="EasyRangeFab" onClick={props.plus}>
      +
    </Button>
  </div>
);

export default easyRange;



// WEBPACK FOOTER //
// ./src/components/EasyRange/EasyRange.jsx